// import React, { useCallback, useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import AppLayout from "@/components/AppLayout";
// import api from "@/lib/api";
// import GigCard from "@/components/shared/GigCard";
// import EmptyState from "@/components/shared/EmptyState";
// import { Button } from "@/components/ui/button";
// import { Plus } from "lucide-react";
// import { toast } from "sonner";

// export default function MyGigs() {
//   const [gigs, setGigs] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const loadGigs = useCallback(async () => {
//     try {
//       setLoading(true);

//       const { data } = await api.get("/opportunities", {
//         params: {
//           mine: true,
//           include_ended: true,
//         },
//       });

//       setGigs(data || []);
//     } catch (e) {
//       toast.error(
//         e?.response?.data?.detail || "Failed to load your gigs"
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     loadGigs();
//   }, [loadGigs]);

//   return (
//     <AppLayout>
//       <div className="flex items-center justify-between gap-4 flex-wrap">
//         <div>
//           <h1 className="font-display text-3xl font-bold tracking-tight">
//             My Gigs
//           </h1>
//           <p className="mt-1 text-sm text-slate-500">
//             Manage the gigs you have posted.
//           </p>
//         </div>

//         <Link to="/opportunities/new">
//           <Button
//             data-testid="my-gigs-post-button"
//             className="bg-[#4F46E5] hover:bg-[#4338CA] text-white"
//           >
//             <Plus className="w-4 h-4 mr-2" />
//             Post a Gig
//           </Button>
//         </Link>
//       </div>

//       {loading ? (
//         <div className="mt-8 text-sm text-slate-500">
//           Loading your gigs…
//         </div>
//       ) : gigs.length === 0 ? (
//         <div className="mt-8">
//           <EmptyState
//             title="You haven't posted any gigs yet"
//             description="Create your first gig and start receiving applications."
//             action={
//               <Link to="/opportunities/new">
//                 <Button
//                   className="bg-[#4F46E5] hover:bg-[#4338CA] text-white"
//                   data-testid="my-gigs-empty-post-button"
//                 >
//                   Post your first gig
//                 </Button>
//               </Link>
//             }
//           />
//         </div>
//       ) : (
//         <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
//           {gigs.map((gig) => (
//             <GigCard
//               key={gig.opportunity_id}
//               opportunity={gig}
//             />
//           ))}
//         </div>
//       )}
//     </AppLayout>
//   );
// }



import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";
import GigCard from "@/components/shared/GigCard";
import EmptyState from "@/components/shared/EmptyState";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { toast } from "sonner";

export default function MyGigs() {
  const [gigs, setGigs] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadGigs = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/opportunities", { params: { mine: true, include_ended: true } });
      setGigs(data || []);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed to load your gigs");
    } finally { setLoading(false); }
  }, []);

  useEffect(() => {
    loadGigs();
    const timer = setInterval(loadGigs, 15000);
    return () => clearInterval(timer);
  }, [loadGigs]);

  return (
    <AppLayout>
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div><h1 className="font-display text-3xl font-bold tracking-tight">My Gigs</h1><p className="mt-1 text-sm text-slate-500">Manage the gigs you have posted.</p></div>
        <Link to="/opportunities/new"><Button data-testid="my-gigs-post-button" className="bg-[#4F46E5] hover:bg-[#4338CA] text-white"><Plus className="w-4 h-4 mr-2" />Post a Gig</Button></Link>
      </div>
      {loading ? <div className="mt-8 text-sm text-slate-500">Loading your gigs…</div> : gigs.length === 0 ? (
        <div className="mt-8"><EmptyState title="You haven't posted any gigs yet" description="Create your first gig and start receiving applications." action={<Link to="/opportunities/new"><Button className="bg-[#4F46E5] hover:bg-[#4338CA] text-white" data-testid="my-gigs-empty-post-button">Post your first gig</Button></Link>} /></div>
      ) : <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">{gigs.map((gig) => <GigCard key={gig.opportunity_id} opportunity={gig} />)}</div>}
    </AppLayout>
  );
}
